/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { useAuth0 } from '@auth0/auth0-react';
import { SignOutButton } from '@clerk/react';
import { Bell, IconColors, Logout, User } from 'Icons';
import React from 'react';
import { Link } from 'react-router-dom';
import { TEMP_DIRECT_LINK } from 'Shared/constants';
import { useTranslation } from 'react-i18next';
import { FlexWrapper } from '../../../../Shared/FlexWrapper';
import useSubscription from '../../../Subscription/useSubscription';
import styles from './user-panel.module.css';
import { AuthProvider } from 'Core/Types/AuthProviders';

const iconAspect = '1.25rem';

function UserPanel(): React.ReactElement {
    const { authProvider } = useSubscription();
    const { t } = useTranslation(['common']);
    const { logout } = useAuth0();
    const { clearUser } = useSubscription();

    return (
        <div className={styles.UserPanel} data-qa="user-panel">
            <Link data-qa-navigation-link="Account" to="/account">
                <FlexWrapper align="center" justify="start" gap="0.5rem">
                    <User aspect={iconAspect} color={IconColors.Action} />
                    <p style={{ color: IconColors.Action }}>{t('common:account')}</p>
                </FlexWrapper>
            </Link>
            <Link data-qa-navigation-link="Notifications" to="/notifications">
                <FlexWrapper align="center" justify="start" gap="0.5rem">
                    <Bell aspect={iconAspect} color={IconColors.Action} />
                    <p style={{ color: IconColors.Action }}>{t('common:notifications')}</p>
                </FlexWrapper>
            </Link>
            {authProvider === AuthProvider.Clerk ? (
                <div
                    className={styles.UserPanelLink}
                    onClick={() => {
                        sessionStorage.removeItem(TEMP_DIRECT_LINK);
                        clearUser();
                    }}
                    data-qa="sign-out"
                >
                    <FlexWrapper align="center" justify="start" gap="0.5rem">
                        <SignOutButton redirectUrl={`${BASE_PATH}/logout.html`}>
                            <p style={{ color: IconColors.Warning }}>{t('common:signOut')}</p>
                        </SignOutButton>
                    </FlexWrapper>
                </div>
            ) : (
                <div
                    className={styles.UserPanelLink}
                    onClick={() => {
                        sessionStorage.removeItem(TEMP_DIRECT_LINK);
                        clearUser();
                        logout({
                            returnTo: `${BASE_PATH}/logout.html`,
                        });
                    }}
                    data-qa="sign-out"
                >
                    <FlexWrapper align="center" justify="start" gap="0.5rem">
                        <Logout aspect={iconAspect} color={IconColors.Warning} />
                        <p style={{ color: IconColors.Warning }}>{t('common:signOut')}</p>
                    </FlexWrapper>
                </div>
            )}
            <div className={styles.TermsAndPrivacyContainer}>
                <Link
                    className={styles.TermsAndPrivacyLink}
                    to="/terms-of-service"
                    data-qa-navigation-link="TermsAndConditions"
                >
                    {t('common:termsOfService')}
                </Link>
                <Link className={styles.TermsAndPrivacyLink} to="/privacy-policy" data-qa-navigation-link="PrivacyPolicy">
                    {t('common:privacyPolicy')}
                </Link>
            </div>
        </div>
    );
}

export default UserPanel;
